import { render, staticRenderFns } from "./RsaPazientePrescrizioneSoluzioneComponent.vue?vue&type=template&id=29d714a6&scoped=true"
import script from "./RsaPazientePrescrizioneSoluzioneComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneSoluzioneComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePrescrizioneSoluzioneComponent.vue?vue&type=style&index=0&id=29d714a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d714a6",
  null
  
)

export default component.exports